import React, { useRef, useState, useEffect } from 'react';
import { Typography, Grid, Tooltip } from '@mui/material';
import { startCase, toLower } from 'lodash';

const capitalizeName = str => {
  if (!str) return '';
  return startCase(toLower(String(str)));
};

const HotelName = ({ name, isFromMap }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    }
  }, [name]);

  const typographyProps = {
    ref: textRef,
    component: 'span',
    sx: {
      fontSize: { xs: isFromMap ? 18 : 22, sm: isFromMap ? 16 : 18 },
      fontWeight: 600,
      color: '#000000',
      textTransform: 'capitalize',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: { xs: '22px', sm: '20px' },
    },
  };

  return (
    <Grid item sx={{ maxWidth: '100%' }}>
      {isTruncated ? (
        <Tooltip
          title={capitalizeName(name)}
          arrow
          placement="top"
          PopperProps={{ disablePortal: true }}
        >
          <Typography {...typographyProps}>
            {String(name)?.toLowerCase()}
          </Typography>
        </Tooltip>
      ) : (
        <Typography {...typographyProps}>
          {String(name)?.toLowerCase()}
        </Typography>
      )}
    </Grid>
  );
};

export default HotelName;
